import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../common_components/Button";

function MissionHeader({ mission }) {
    const navigate = useNavigate();
    return (
        <div className="mission-header">
            <div className="mission-header-title-container">
                <h3 className="gray-mission-text-title">
                    Missions
                </h3>
                <h2 className="white-text">{mission.name}</h2>
            </div>
            <div className="mission-header-back-container desktop-only">
                <Button size="small" color="gray" onClick={() => navigate("/missions")}>
                    Return to list
                </Button>
            </div>
        </div>
    )
}

export default MissionHeader;